import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Button, Grid2, Stack, useTheme } from '@mui/material';
import TableComponent from 'components/grid';
import { FaPlus } from 'react-icons/fa6';
import { useGetAllScheduleDPRListQuery } from 'store/slices/apis/scheduleDprSlice';
import moment from 'moment';
import PaginationComponent from 'components/ui-components/PaginationComponent';
import { ReactComponent as PlusIcon } from "assets/PwC_Funct_Icons_Plus_Outline_Black_RGB.svg"
import {ReactComponent as AddNewIcon} from "assets/PwC_Funct_Icons_Plus_Outline_Black_RGB.svg"

const columns = [
    {
        name: 'Reporting Date',
        field: 'reportedDate',
        renderer(params) {
            return (
                <>
                    {params?.reportedDate
                        ? moment(params?.reportedDate).format("DD-MM-YYYY")
                        : "N.A."}
                </>
            );
        },
    },
    {
        name: 'Activity Count',
        field: 'activityCount',
    },
    {
        name: 'Submitted On',
        field: 'createddate',
        renderer(params) {
            return (
                <>
                    {params?.createddate
                        ? moment(params?.createddate).format("DD-MM-YYYY")
                        : "N.A."}
                </>
            );
        },
    },
    {
        name: 'Action',
        field: "action",
        option: {
            view: true
        },
    }
];

const QuantityDPR = () => {
    const theme = useTheme();
    const navigate = useNavigate();

    const { projectId } = useParams();
    const [pageNumber, setPageNumber] = useState(1);

    const listResponse = useGetAllScheduleDPRListQuery({ projectId, page: pageNumber, pageSize: 10 });

    const handleCreateNewDpr = () => {
        navigate(`/projects/${projectId}/new_dpr/create-new-dpr`);
    };
    const encrypt = (text) => btoa(unescape(encodeURIComponent(text)));

    const handleActionView = (row) => {
        const encrypted = encrypt("view");
        navigate(`/projects/${projectId}/quantitydpr-detail/${row?.id}/${encrypted}/false`);
    };
    return (
        <>
            <Grid2 container spacing={2} sx={{ mt: '20px' }}>
                <Grid2 size={12}>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                        }}
                    >
                        <Stack
                            direction="row"
                            spacing={2}
                            sx={{
                                flexGrow: 2,
                                alignItems: "center",
                                "& .MuiStack-root": {
                                    paddingTop: "15px",
                                },
                            }}
                        >
                        </Stack>
                        <Button
                            variant="contained"
                            startIcon={
                                // <PlusIcon style={{ fill: "#ffffff", marginBottom: "2px", width: "20px", height: "20px" }} />
                                <AddNewIcon style={{ height: "20px", width: "20px", fill: "#FFFFFF" ,  strokeWidth: 4, stroke:"#FFFFFF" }} />
                            }
                            onClick={handleCreateNewDpr}
                            sx={{
                                backgroundColor: `${theme?.customSettings?.themeColor}`,
                                color: "#FFF",
                                padding: "5px 20px",
                                fontWeight: "500",
                                textTransform: "none",
                                fontSize: "16px",
                                // marginTop: "11px",
                                // marginLeft: '20px',
                                border: `1px solid ${theme?.customSettings?.themeColor}`,
                                '&.Mui-disabled': {
                                    border: 'none'
                                }
                            }}
                        >
                            New DPR
                        </Button>
                    </Box>
                </Grid2>
                <Grid2 size={12} sx={{ mt: 0 }}>
                    <TableComponent
                        columns={columns}
                        data={listResponse?.data?.data?.dprs}
                        isLoading={listResponse?.isLoading}
                        actionView={handleActionView}
                    />
                    {!listResponse?.isLoading && (
                        <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                            <PaginationComponent
                                pageNumber={listResponse?.data?.data?.page || 1}
                                totalPages={Math.ceil(listResponse?.data?.data?.totalRecords / listResponse?.data?.data?.pageSize) || 1}
                                onPageChange={setPageNumber}
                            />
                        </Box>
                    )}
                </Grid2>
            </Grid2>
        </>
    );
};

export default QuantityDPR;